import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Subject } from "rxjs";
import { HeaderService } from "src/app/_services/header.service";
import { SpaceType } from "src/app/_types/space-type";
import { HeaderModel } from "../../_component/header/header.model";
import { SpaceAssignmentModel } from "../../_models/space-assignment.model";
import { UserService } from "../../_services";
import { BookingService } from "../../_services/booking.service";
import { ThisPlatform } from "../../_services/platform.service";
import { PushNotificationService } from "../../_services/push-notification.service";
import { SpaceService } from "../../_services/space.service";
import { BuildingService } from "../building/building.service";
import { FloorService } from "../building/floor/floor.service";
import { SpaceDateFilterService } from "../_component/_space/space-date-filter/space-date-filter.service";
import { SpaceFilter } from "../_component/_space/space-filter/space-filter.model";
import { SpaceFilterService } from "../_component/_space/space-filter/space-filter.service";
import { UserAssignmentViewQuickShareComponent } from "../_component/_space/user-assignment-view/user-assignment-view-share-space/user-assignment-view-quick-share.component";
import { ParkingService } from "./parking.service";

@Component({
  selector: "app-parking",
  templateUrl: "./parking.page.html",
  styleUrls: ["./parking.page.scss"],
})
export class ParkingPage implements OnInit {
  constructor(
    public parkingServ: ParkingService,
    public p: ThisPlatform,
    public floorServ: FloorService,
    public buildingServ: BuildingService,
    public bookingService: BookingService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private spaceService: SpaceService,
    private modalCtrl: ModalController,
    private spaceFilterServ: SpaceFilterService,
    private spaceDateFilterService: SpaceDateFilterService,
    private pushNotificationService: PushNotificationService,
    private headerServ: HeaderService,
  ) {}

  barriers;

  activeSegment: string;

  spaceType = SpaceType.Parking;

  page: string;
  defaultPage: string = "parking_my_reservations";

  spaceToShare: SpaceAssignmentModel = new SpaceAssignmentModel();
  isParkingConfirmationDisplayed: boolean = false;

  headerInit: HeaderModel = {
    title: "Parking",
    userSettingsBreakpoint: 1250,
    segmentsChangeFunc: ($event) => this.segmentChanged($event),
    segments: [
      {
        name: "SPACE.MY_RESERVATIONS",
        value: "parking_my_reservations",
        permissionKeys: ["parking.segment.reservations-view"],
      },
      {
        name: "SPACE.ALL_RESERVATIONS",
        value: "parking_all_reservations",
        permissionKeys: ["parking.reservation.all"],
      },
      {
        name: "SPACE.PARKING.ALL_PARKING_PLACES",
        value: "parking_space",
        permissionKeys: ["parking.segment.spaces"],
      },
      {
        name: "Mapy",
        value: "parking_map",
        permissionKeys: ["parking.segment.spaces"],
      },
    ],
  };

  eventsSubject: Subject<void> = new Subject<void>();

  segmentsArray = [];

  nextSegment: string;
  prevtSegment: string;

  async ngOnInit() {
    await this.userService.getPermision();
    this.userService.refreshCurrentUser();
    
    this.headerInit.segments.forEach((segment) => {
      if (this.userService.hasRoles(segment.permissionKeys)) {
        this.segmentsArray.push(segment.value);
      }
    });

    if (this.p.renderMobile) {
      this.headerInit.segments.pop();
    }

    
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.get("section") || params.get("confirm")) {
        this.page = params.get("section");

        this.eventsSubject.next();

        if (this.segmentsArray.filter((el) => el == this.page).length > 0) {
          this.activeSegment = this.page;
        } else {
          this.activeSegment = this.segmentsArray[0];
          this.setQueryParam(this.segmentsArray[0]);
        }
        
        if (params.get("confirm") !== null) {
          if (!this.isParkingConfirmationDisplayed) {
            this.isParkingConfirmationDisplayed = true;

            this.spaceService
              .getAssignment(parseInt(params.get("confirm")))
              .subscribe((res) => {
                this.shareParkingSpaceWhenLeaving(res, params.get("confirm"));
              });
            }
        }
      } else {
        this.activeSegment = this.segmentsArray[0];
        this.setQueryParam(this.segmentsArray[0]);
        this.headerServ.setHeaderInit(this.headerInit);
      }
    });
  }
  
  ionViewWillEnter() {
    this.headerInit.activeSegment = this.activeSegment;
    this.headerServ.setHeaderInit(this.headerInit);
  }
  
  segmentChanged($event) {
    this.page = $event.detail.value;
    this.spaceFilterServ.filterDetails = new SpaceFilter();
    this.spaceDateFilterService.filterLoadedFloors = [];
    this.bookingService.bookingsCounter = null;
    this.spaceService.assignmentsCounter = null;
    
    this.setQueryParam($event.detail.value);
  }
  
  setQueryParam(value) {
    setTimeout(() => {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { section: value },
        queryParamsHandling: "merge", // remove to replace all query params by provided
      });
    }, 50);
  }

  async shareParkingSpaceWhenLeaving(item, pushIdConfirmation) {
    const modal = await this.modalCtrl.create({
      component: UserAssignmentViewQuickShareComponent,
      animated: true,
      cssClass: "add-edit-modal",
      componentProps: {
        assignmentDetails: item,
        pushIdConfirmation: pushIdConfirmation,
        notificationConfirmation: true,
      },
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      this.pushNotificationService
        .pushConfirmation(pushIdConfirmation, "confirmed")
        .subscribe();
      if (data.role == "share") {
        this.isParkingConfirmationDisplayed = false;
        this.spaceService.onAssignmentChange();
        this.router.navigate(["app/parking"]);
      }
    });
  }

  ionViewDidLeave() {
    this.page = null;
  }
}
